import CrmDealsAPI from 'dashboard/api/crmDeals';

const state = {
  records: [],
  currentDeal: null,
  funnelData: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingFunnel: false,
  },
};

const getters = {
  getDeals: $state => $state.records,
  getCurrentDeal: $state => $state.currentDeal,
  getFunnelData: $state => $state.funnelData,
  getUIFlags: $state => $state.uiFlags,
  getDealById: $state => id => $state.records.find(d => d.id === id),
  getDealsByStage: $state => stageId =>
    $state.records.filter(d => d.crm_stage_id === stageId),
  getDealsByContact: $state => contactId =>
    $state.records.filter(d => d.contact_id === contactId),
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmDealsAPI.get(params);
      commit('SET_DEALS', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show({ commit }, id) {
    try {
      const { data } = await CrmDealsAPI.show(id);
      commit('SET_CURRENT_DEAL', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    }
  },

  async create({ commit }, dealData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await CrmDealsAPI.create(dealData);
      commit('ADD_DEAL', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...dealData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.update(id, dealData);
      commit('UPDATE_DEAL', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await CrmDealsAPI.delete(id);
      commit('DELETE_DEAL', id);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async move({ commit }, { id, stageId }) {
    try {
      const { data } = await CrmDealsAPI.move(id, stageId);
      commit('UPDATE_DEAL', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    }
  },

  async finalize({ commit }, { id, finalStageType }) {
    try {
      await CrmDealsAPI.finalize(id, finalStageType);
      commit('DELETE_DEAL', id);
    } catch (error) {
      throw error;
    }
  },

  async fetchFunnel({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetchingFunnel: true });
    try {
      const { data } = await CrmDealsAPI.funnel(params);
      commit('SET_FUNNEL_DATA', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetchingFunnel: false });
    }
  },

  async fetchByContact({ commit }, contactId) {
    try {
      const { data } = await CrmDealsAPI.getByContact(contactId);
      return data.payload;
    } catch (error) {
      throw error;
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  SET_DEALS($state, deals) {
    $state.records = deals;
  },
  SET_CURRENT_DEAL($state, deal) {
    $state.currentDeal = deal;
  },
  SET_FUNNEL_DATA($state, funnelData) {
    $state.funnelData = funnelData;
  },
  ADD_DEAL($state, deal) {
    $state.records.push(deal);
  },
  UPDATE_DEAL($state, deal) {
    const index = $state.records.findIndex(d => d.id === deal.id);
    if (index !== -1) {
      $state.records.splice(index, 1, deal);
    }
  },
  DELETE_DEAL($state, id) {
    $state.records = $state.records.filter(d => d.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
